/* Limites du format personnalise - modifier ici seulement.

   AIRE_MAX : au-dela, le prix bascule sur soumission. La regle est simple et
   elle doit le rester : ON NE PRICE QUE CE QUE LA GRILLE COUVRE. Elle valait
   288 po2 (12 x 24) tant que la grille s arretait au 12 po ; depuis le
   5 septembre 2026 la grille monte au 36 po, donc 1296 po2 (36 x 36).
   C est la signalisation routiere qui l a impose : un panneau du MTQ fait
   couramment 600 mm de cote, soit 558 po2, et il tombait dans la soumission
   alors que son prix existe maintenant. Les panneaux d autoroute, eux, font
   1800 mm et plus : ils depassent cette limite, et c est voulu qu ils partent
   en soumission.

   ATTENTION quand meme : le prix est calcule sur la SURFACE, pas sur la
   forme. Une bande de 6 x 216 po fait la meme surface qu un carre de 36 po et
   sera facturee pareil, alors qu elle coute moins cher a produire. Tant que
   personne n en commande, ca ne se voit pas ; le jour ou ca arrive, il faudra
   une regle par laize plutot que par surface.

   LARGEUR_MAX : largeur imprimable de l atelier (~52 po sur media de 54 po).

   ATTENTION, DEUX FICHIERS PORTENT DES BORNES DEPUIS LE 6 SEPTEMBRE 2026.
   Celui-ci borne le FORMAT PERSONNALISE saisi a la main. assets/scdm-limites.js
   borne le configurateur en entier (MAX_PETIT 52 po, MAX_GRAND 240 po,
   SEUIL_COLIS 60 po, AIRE_MAX_SOUPLE 1296 po2) et c est lui qui bloque le
   bouton d ajout au panier. Si on change une borne ici sans changer l autre,
   le client verra un prix que le panier refusera ensuite : toujours regarder
   les deux.

   LES DEUX SONT ALIGNES A 52 PO DEPUIS LE 11 SEPTEMBRE 2026. scdm-limites.js
   bornait encore a 50 : une piece de 51 po affichait un prix ici et se faisait
   refuser au panier la. La valeur est unique maintenant, ne la desaccordez
   plus.

   LES DEUX UNITES DANS LES MESSAGES - 11 septembre 2026. Decision du
   proprietaire : tout chiffre montre au client porte les pouces ET les
   millimetres. 1 po = 25,4 mm exactement. Les bornes ci-dessous restent en
   POUCES - seul le texte affiche porte les deux unites. */
window.SCDM_CUSTOM = {
  MIN_COTE: 0.5,
  LARGEUR_MAX: 52,
  LONGUEUR_MAX: 240,
  AIRE_MAX: 1296,
  MSG_TROP_LARGE: 'Plus large que notre laize d’impression (52 po / 1321 mm). Faisable en plusieurs lés — demandez une soumission.',
  MSG_TROP_GRAND: 'Au-delà de 36 × 36 po (914 × 914 mm), le prix se calcule au pied carré et non à l’autocollant. Demandez une soumission : réponse sous 2 jours ouvrables.',
  MSG_TROP_PETIT: 'Minimum ½ po (13 mm) par côté.'
};

window.SCDM_CUSTOM.MSG_TROP_LONG = 'Au-delà de 240 po (6096 mm) de long, demandez une soumission.';
(function () {
  var textes = document.getElementById('scdmLimitesI18n');
  if (!textes) return;
  var cles = { MSG_TROP_LARGE: 'custom_wide', MSG_TROP_LONG: 'custom_long', MSG_TROP_GRAND: 'custom_area', MSG_TROP_PETIT: 'custom_small' };
  Object.keys(cles).forEach(function (cle) {
    var traduit = textes.getAttribute('data-limit-' + cles[cle]);
    if (traduit && traduit.trim()) window.SCDM_CUSTOM[cle] = traduit;
  });
})();

/* THEME 26 — photo du GF 110 EraseMark PRO sur la page Matériaux. */
(function () {
  var photo = 'https://cdn.shopify.com/s/files/1/1001/0184/9368/files/scdm-materiaux-gf-110-erasemark-v2.png?v=1790342844';
  function remplacerPhotoGF110() {
    document.querySelectorAll('img[alt="GF 110 EraseMark PRO™"]').forEach(function (image) {
      image.src = photo;
      image.srcset = photo;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', remplacerPhotoGF110);
  else remplacerPhotoGF110();
  new MutationObserver(remplacerPhotoGF110).observe(document.documentElement, { childList: true, subtree: true });
})();
